/**
 * The product, photographed rather than described.
 *
 * These were drawings of the app: approximations that looked right the day
 * they were written and would quietly rot the moment a screen changed. They
 * are now screenshots of the real components, taken by scripts/make-shots.mjs
 * against src/dev/Shots.tsx, so re-running that script is all it takes to keep
 * the site honest about what the product looks like.
 *
 * The frames around them are still CSS — a laptop and a phone drawn in the
 * site's own lines, so no stock device photograph is needed. Every figure in
 * the screenshots is invented, and each frame says Sample.
 */

import styles from './Mockups.module.css'

/** The agent's desk: money due across the book, and the fee on it. */
export function DeskMockup() {
  return (
    <figure className={styles.laptop}>
      <div className={styles.screen}>
        <div className={styles.appBar}>
          <span className={styles.appMark}>Reppr</span>
          <span className={styles.appCrumb}>Money</span>
          <span className={styles.sample}>Sample</span>
        </div>
        <img
          className={styles.shot}
          src="/shots/desk.png"
          width={1640}
          height={834}
          alt="The Money screen in Reppr: a dated list of payments across the roster — a paycheck for Marcus Ellison the week of Oct 6 at $25K with a $737 fee, a $45K endorsement payment for Devin Marsh — and, below, a contract whose paycheck schedule the agency has not confirmed yet."
        />
      </div>
      <div className={styles.laptopBase} aria-hidden="true" />
    </figure>
  )
}

/** What the athlete opens: their own money, in their own words. */
export function PortalMockup() {
  return (
    <figure className={styles.phone}>
      <div className={styles.phoneScreen}>
        <div className={styles.phoneBar}>
          <span className={styles.phoneTitle}>Your money</span>
          <span className={styles.sample}>Sample</span>
        </div>
        <img
          className={styles.shot}
          src="/shots/portal.png"
          width={760}
          height={1520}
          alt="The athlete's own page: $94,583 due in the next thirty days and $49,166 received in the last thirty, then each payment by week — the next game check, an endorsement instalment — and the game checks that have already arrived."
        />
      </div>
    </figure>
  )
}
